// Feature flags set by the server in index.html (see server/features.js)
const FEATURES = (typeof window !== 'undefined' && window.NC_FEATURES) || {};

export const isFeatureEnabled = (name) => Boolean(FEATURES[name]);
